<template>
  <div>
    <h1>{{ 'd_ws_title' | translate }}</h1>
    <h3>{{ $store.deviceStartData.device.name }}</h3>

    <form @submit.prevent="login">
      <div class="input-wrapper">
        <input
          v-model="email"
          type="email"
          :placeholder="'d_ws_login_email' | translate"
        >
        <i class="ri-mail-line ri-fw" />
      </div>

      <div class="input-wrapper">
        <input
          v-model="password"
          :type="!passwordVisibility ? 'password' : 'text'"
          :placeholder="'d_ws_login_password' | translate"
        >
        <i class="ri-key-line ri-fw" />
        <i
          class="password-visibility"
          :class="[ !passwordVisibility ? 'ri-eye-off-line' : 'ri-eye-line' ]"
          @click="passwordVisibility = !passwordVisibility"
        />
        <button @click="recoverPassword()" type="button">{{ 'd_ws_restore_password' | translate }}</button>
      </div>

      <button
        class="secondary"
        :disabled="!isFormFilled || loginDisable"
      >
        {{ 'd_ws_login' | translate }}
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'SignInForm',
  emits: ['recover-password'],
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      passwordVisibility: false,
      loginDisable: false
    }
  },
  computed: {
    isFormFilled: function() {
      return this.email.length !== 0 && this.password.length !== 0;
    }
  },
  methods: {
    recoverPassword() {
      this.$emit('recover-password');
    },
    login() {
      if (!this.loginDisable) {
        this.loginDisable = true;
        this.$crudService.post('login', {
          email: this.email,
          password: this.password,
          operator_workspace_id: this.$store.deviceStartData.device.device_id
        }).then(({ data }) => {
          if (data && data.access_token && data.refresh_token && data.user) {
            this.$authService.login(data.access_token, data.refresh_token, data.user);
            this.$store.userRole = this.$authService.getRole(data.user)
          }
          this.loginDisable = false;
        }).catch((err) => {
          if(err.response && err.response.data && err.response.data.code && err.response.data.code === this.$ERROR_CODE.WITHOUT_WINDOW && err.response.status === 403) {
            this.$notificationService.error('d_ws_error_without_window')
          } else if (err.response && err.response.data && err.response.data.code && err.response.data.code === this.$ERROR_CODE.WRONG_CREDENTIALS && err.response.status === 403) {
            this.$notificationService.error('wrong_login_or_password')
          }

          this.loginDisable = false;
        })
      }
    }
  }
}
</script>
